export const userConstants = {
    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

    RESETPASSWORD_REQUEST: 'USERS_RESETPASSWORD_REQUEST',
    RESETPASSWORD_SUCCESS: 'USERS_RESETPASSWORD_SUCCESS',
    RESETPASSWORD_FAILURE: 'USERS_RESETPASSWORD_FAILURE',

    SETPASSWORD_REQUEST: 'USERS_SETPASSWORD_REQUEST',
    SETPASSWORD_SUCCESS: 'USERS_SETPASSWORD_SUCCESS',
    SETPASSWORD_FAILURE: 'USERS_SETPASSWORD_FAILURE',

    ACTIVATE_REQUEST: 'USERS_ACTIVATE_REQUEST',
    ACTIVATE_SUCCESS: 'USERS_ACTIVATE_SUCCESS',
    ACTIVATE_FAILURE: 'USERS_ACTIVATE_FAILURE',

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    LOGOUT: 'USERS_LOGOUT',

    UPDATE_REQUEST: 'USERS_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'USERS_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'USERS_UPDATE_FAILURE',

    UPDATENOORG_REQUEST: 'USERS_UPDATENOORG_REQUEST',
    UPDATENOORG_SUCCESS: 'USERS_UPDATENOORG_SUCCESS',
    UPDATENOORG_FAILURE: 'USERS_UPDATENOORG_FAILURE',

    SUBMITSTRIPE_REQUEST: 'USERS_SUBMITSTRIPE_REQUEST',
    SUBMITSTRIPE_SUCCESS: 'USERS_SUBMITSTRIPE_SUCCESS',
    SUBMITSTRIPE_FAILURE: 'USERS_SUBMITSTRIPE_FAILURE',

    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',

    GETOWN_REQUEST: 'USERS_GETOWN_REQUEST',
    GETOWN_SUCCESS: 'USERS_GETOWN_SUCCESS',
    GETOWN_FAILURE: 'USERS_GETOWN_FAILURE',

    GETBYEMAIL_REQUEST: 'USERS_GETBYEMAIL_REQUEST',
    GETBYEMAIL_SUCCESS: 'USERS_GETBYEMAIL_SUCCESS',
    GETBYEMAIL_FAILURE: 'USERS_GETBYEMAIL_FAILURE',

    DELETE_REQUEST: 'USERS_DELETE_REQUEST',
    DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
    DELETE_FAILURE: 'USERS_DELETE_FAILURE',
};



// WEBPACK FOOTER //
// ./src/_constants/user.constants.js